import { ListRenderer } from '@feast-it/ui/light';
import React, { ReactElement } from 'react';

import { isExternal } from '../../../modules/externalLink';
import {
  Area,
  StyledHeading,
  StyledList,
  StyledListItem,
  StyledLink,
  InternalLink,
} from '../Footer.styled';
import { useIsDarkTheme } from '../../../context/DarkThemeContext';

interface FooterNavigationItem {
  text: string;
  href: string;
  onClick?: () => void;
  as?: string;
}

interface FooterNavigationGroup {
  heading: string;
  items: FooterNavigationItem[];
}

interface FooterNavigationRecord {
  [key: string]: FooterNavigationGroup;
}

interface SectionLinksProps {
  navigation: FooterNavigationRecord;
}

export function SectionLinks({ navigation }: SectionLinksProps): ReactElement {
  const isDark = useIsDarkTheme();

  return (
    <ListRenderer
      items={Object.keys(navigation)}
      render={({ item: sectionKey }) => {
        const section = navigation[sectionKey];

        return (
          <Area name={sectionKey} as="nav">
            <StyledHeading
              as="h2"
              style="headingBoldMobileExtraSmall"
              color={isDark ? 'white' : 'black'}
            >
              {section.heading}
            </StyledHeading>

            <StyledList>
              <ListRenderer
                items={section.items}
                render={({ item }) => (
                  <StyledListItem>
                    {isExternal(item.href) ? (
                      <StyledLink
                        href={item.href}
                        onClick={item.onClick}
                        isDark={isDark}
                      >
                        {item.text}
                      </StyledLink>
                    ) : (
                      <StyledLink href={item.href} prefetch={false}>
                        <InternalLink onClick={item.onClick} isDark={isDark}>
                          {item.text}
                        </InternalLink>
                      </StyledLink>
                    )}
                  </StyledListItem>
                )}
              />
            </StyledList>
          </Area>
        );
      }}
    />
  );
}
